import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_REPORTED_TAX_TYPE_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
